import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .card-title {
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    color: ${redesignedTheme.colors.mineShaft};
    box-sizing: border-box;
  }
  
  .card-description {
    order: 3;
    display: flex;
    margin-top: 10px;
    font-family: Graphik;
    line-height: 130%;
    color: ${redesignedTheme.colors.mineShaft};
    font-weight: 400;
    font-size: 16px;
    line-height: 156%;
  }
  
  .timestamp {
    display: inline-block;
    float: left;
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 13px;
    color: ${theme.colors.lightGray5};
  }
    
  .meatball-icon {
    float: right;
    padding: 0 8px;
    height: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
  }
  
  .image-container {
    position: relative;
    width: fit-content;
    height: auto;
  }
  
  .duration-pill-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 8px;
    left: 8px;
    width: 48px;
    height: 18px;
    background: ${redesignedTheme.colors.lightBlue};
    border-radius: 25px;
  }
  
  .duration-time {
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: white;
    line-height: 100%;
    margin-top: 1px;
    max-height: 10px;
    -webkit-text-size-adjust: none;
  }
  
  .duration-time span {
    display: inline-block;
    height: 100%;
  }
  
  .play-icon {
    height: 8px;
    width: 8px;
    padding-right: 1px;
    margin: 0;
  }  
`
